import { Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FirebaseOptions } from '@angular/fire';
import { environment } from '../../environments/environment';
import { FirebaseService } from './firebase.service';
import { AngularFireStorage } from '@angular/fire/storage';

// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class AngularfirestoreCoolStoreService extends AngularFirestore { }

const settings = {};

export function AngularfirestoreCoolStoreFactory(platformId: Object, zone: NgZone) {
  return new AngularFirestore(environment.coolstore, 'coolstore', false, null, platformId, zone, settings, null, null);
}

export class AngularfirestorePerfectStoreService extends AngularFirestore { }

export function AngularfirestorePerfectStoreFactory(platformId: Object, zone: NgZone) {
  return new AngularFirestore(environment.perfectstore, 'perfectstore', false, null, platformId, zone, settings, null, null);
}

export class AngularfirestoreCoolStorageService extends AngularFireStorage { }

export function AngularfirestoreCoolStorageFactory(platformId: Object, zone: NgZone) {
  return new AngularFireStorage(environment.coolstore, 'coolStorage', `gs://${environment.coolstore.storageBucket}/`, platformId, zone, null, null);
}

export class AngularfirestoreCustomerService extends AngularFireStorage { }

export function AngularfirestoreCustomerFactory(platformId: Object, zone: NgZone, bucket) {
  return new AngularFireStorage(environment.coolstore, 'customerStorage', bucket, platformId, zone, null, null);
}

//Video Database mona-videos
export class AngularfirestoreVideoStoreService extends AngularFirestore { }

export function AngularfirestoreVideoStoreFactory(platformId: Object, zone: NgZone) {
  return new AngularFirestore(environment.videoStore, 'videoStore', false, null, platformId, zone, settings, null, null);
}

export class AngularfirestoreVideoStorageService extends AngularFireStorage { }

export function AngularfirestoreVideoStorageFactory(platformId: Object, zone: NgZone) {
  return new AngularFireStorage(environment.videoStore, 'videoStorage', "gs://mona-videos-ccd72.appspot.com", platformId, zone, null, null);
}

